import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface IntegrationConnectedToOtherServiceTooltipProps {
  openLeft: boolean
  showToolTip?: boolean
}

const IntegrationConnectedToOtherServiceTooltip: React.FC<
  IntegrationConnectedToOtherServiceTooltipProps
> = (props): React.ReactElement => {
  return (
    <Tooltip
      css={css`
        z-index: 1;
      `}
      openLeft={props.openLeft}
      showToolTip={props.showToolTip}
    >
      <p>
        <Trns
          source={
            '${alreadyConnected} Because of the way these expense management integrations apply across your profile, you cannot be connected to more than one at a time.'
          }
          expressions={{
            alreadyConnected: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns
                  source={
                    'Already connected to another expense management tool.'
                  }
                />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default IntegrationConnectedToOtherServiceTooltip
